module.exports = __webpack_public_path__ + "static/img/storageBottom2.509487a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageBottom2.png
// module id = zMxm
// module chunks = 2